<template>
<div @click="popupButtonAction" class="header_feedback">
        <a-popover position="bottom" :trigger="['click']" :popup-visible="popupVisibale" arrow-class="header_feedback_arrow" content-class="header_rate_feedback_content" @click="showFeedbackTip = false">
            <a-tooltip :content="$t('反馈')" content-class="rate_button_tooltip" arrow-class="rate_button_tooltip_arrow" :popup-visible="showFeedbackTip">
                <!-- <svg-icon style="font-size: 28px;" name="header-rate_icon"></svg-icon> -->
                <span class="rate_button" @mouseenter="feedbackMouseEnter" @mouseleave="showFeedbackTip = false">{{$t("反馈")}}</span>
            </a-tooltip>
            <!-- popup container -->
            <template v-if="popupContainerType == 'popup'" #content>
                <div class="popup_container">
                    <div class="popover_container_item" @click="rateButtonAction">
                        <svg-icon name="header-grey_star"></svg-icon>
                        <span>{{$t("满意度评分")}}</span>
                    </div>
                    <div style="height: 4px;"></div>
                    <div class="popover_container_item" @click="feedbackButtonAction">
                        <svg-icon name="header-grey_tips"></svg-icon>
                        <span>{{$t("问题反馈")}}</span>
                    </div>
                </div>
            </template>
            <!-- feedback container -->
            <template v-else #content>
                <div class="feedback_popup_container">
                    <div class="feed_title_container">
                        <div class="feed_title">{{$t("给管家文档打个分吧～")}}</div>
                        <div class="feed_close_btn" @click="() => (popupVisibale = false)">
                            <svg-icon name="common-close"></svg-icon>
                        </div>
                    </div>
                    <div class="feed_content">
                        <div @mouseenter="() => (hoverFeedItemIndex = index)" @mouseleave="() => (hoverFeedItemIndex = -1)" class="feed_item" v-for="(item, index) in feedItems" :key="index" @click="onRateItemClick(item, index)">
                            <div class="feed_item_score" :class="[
                                    hoverFeedItemIndex === index
                                        ? 'feed_item_score_hover'
                                        : ''
                                ]">
                                {{ item.score }}
                            </div>
                            <div class="feed_item_desc" :class="[
                                    hoverFeedItemIndex === index
                                        ? 'feed_item_desc_hover'
                                        : ''
                                ]" v-html="item.desc"></div>
                        </div>
                    </div>
                </div>
            </template>
        </a-popover>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import UrlRouterUtil from '../../utils/UrlRouterUtil';
import { apiScoreRate } from '../../core/api/score_rate';

export default {
  name: 'RateButton',
  props: {
    initValue: { default: 'init value', type: String } },

  data() {
    return {
      outSideFunc: (undefined as Function | undefined),
      popupVisibale: false,
      popupContainerType: ('popup' as 'popup' | 'feedback'),
      hoverFeedItemIndex: -1,
      feedItems: [
      { score: intl.$t("1分"), desc: intl.$t("不好用<br>完全不行") },
      { score: intl.$t("2分"), desc: intl.$t("凑合能用<br>还行") },
      { score: intl.$t("3分"), desc: intl.$t("符合预期<br>还不错") },
      { score: intl.$t("4分"), desc: intl.$t("超过预期<br>非常好") },
      { score: intl.$t("5分"), desc: intl.$t("天大惊喜<br>太棒了") }],

      showFeedbackTip: false };

  },
  watch: {
    popupVisibale: function (val) {
      if (val === true) {
        setTimeout(() => {
          document.addEventListener(
          'click',
          this.outSideFunc = (e) => {
            let element = (e.target as HTMLElement);
            while (
            element &&
            !element.classList.contains(
            'popover_container_item'))

            {
              element = (element.parentElement as HTMLElement);
            }
            if (element) return;
            this.popupVisibale = false;
            this.outSideFuncDellocate();
          });

        }, 0);
      } else {
        this.outSideFuncDellocate();
      }
    } },

  computed: {},
  methods: {
    feedbackMouseEnter() {
      if (!this.popupVisibale) {
        this.showFeedbackTip = true;
      }
    },
    popupButtonAction() {
      this.popupVisibale = !this.popupVisibale;
      this.popupContainerType = 'popup';
    },
    rateButtonAction() {
      // this.popupVisibale = false;
      this.popupContainerType = 'feedback';
    },
    feedbackButtonAction() {
      this.popupVisibale = false;
      UrlRouterUtil.openUrl(
      'https://task.17usoft.com/share/shrnJEQZhBc54LHkb2Bqc');

    },
    async onRateItemClick(
    item: {score: string;desc: string;},
    index: number)
    {
      const resp = await apiScoreRate(index + 1).catch((e) => {});
      this.popupVisibale = false;
      if (resp && resp.data?.code === 200) {
        this.$message.success(intl.$t("操作成功"));
      } else {
        this.$message.error(intl.$t("操作失败"));
      }
    },
    outSideFuncDellocate() {
      if (this.outSideFunc)
      document.removeEventListener('click', this.outSideFunc);
      this.outSideFunc = undefined;
    } },

  mounted() {},
  unmounted() {
    this.outSideFuncDellocate();
  } };
</script>

<style lang="scss" scoped>
.rate_button {
    font-size: 14px;
    color: #222329;
}
.popup_container {
    width: 146px;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;
    padding: 4px !important;
    box-sizing: border-box;
}

.feedback_popup_container {
    margin-right: 16px;
    width: 301px;
    background-image: linear-gradient(180deg, #ecefff 0%, #ffffff 100%);
    box-shadow: 0 10px 20px 0 #22232926;
    border-radius: 8px;
    padding: 16px 16px 24px 16px;
    .feed_title_container {
        display: flex;
        justify-content: space-between;
        .feed_title {
            font-weight: 500;
            font-size: 15px;
            color: #222329;
        }
        .feed_close_btn {
            width: 18px;
            height: 18px;
            border-radius: 4px;
            color: #979ba5;
            display: flex;
            justify-content: center;
            align-items: center;
            svg {
                font-size: 10px;
            }
            &:hover {
                background: #ffffff;
            }
        }
    }

    .feed_content {
        display: flex;
        justify-content: space-between;
        padding-top: 16px;
        .feed_item {
            width: 40px;
            height: 64px;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 10px;
            cursor: pointer;
            .feed_item_score {
                color: #5c70ff;
                font-weight: 500;
                width: 32px;
                height: 32px;
                border-radius: 18px;
                text-align: center;
                line-height: 32px;
                background-color: white;
                margin-bottom: 4px;
            }
            .feed_item_score_hover {
                color: #ffffff;
                background: #5c70ff;
            }
            .feed_item_desc {
                color: #7b7d82;
                text-align: center;
            }
            .feed_item_desc_hover {
                color: #222329;
            }
        }
    }
}

.popover_container_item {
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
    color: #222329;
    &:hover {
        background: #f4f6f9;
    }
    svg {
        margin-right: 8px;
        font-size: 18px;
    }
}

.header_feedback {
    cursor: pointer;
    width: auto;
    min-width: 36px;
    height: 26px;
    background: #ffffff;
    margin-left: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 400;
    font-size: 14px;
    padding: 0 4px;

    svg {
        font-size: 16px;
    }

    &:hover {
        background: #f4f6f9;
        border-radius: 4px;
    }
}
</style>

<style lang="scss">
.rate_button_tooltip {
    min-width: 44px !important;
    height: 36px !important;
    padding: 0 6px !important;
    background: #ffffff !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
    border-radius: 8px !important;
    text-align: center !important;
    font-family: PingFangSC-Regular !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: #767c85 !important;
    letter-spacing: 0 !important;
    line-height: 36px !important;
}

.rate_button_tooltip_arrow {
    display: none !important;
}

.header_feedback_arrow {
    display: none !important;
}

.arco-popover-content {
    margin-top: 0px;
}
.header_rate_feedback_content {
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: none !important;
    .arco-popover-content {
        margin-top: 0px !important;
    }
}
</style>
